import * as Yup from 'yup';
import { TFormValues } from '../types.ts';
import {
  phoneValidation,
  emailValidation,
  conditionalClientTypeValidation,
  clientTypeSchema,
} from '../validationUtils.ts';
import { errorMessages } from '~/constants/errorMessages.js';

export const validationSchemaManager: Yup.ObjectSchema<TFormValues> = Yup.object({
  financialServices: Yup.boolean().defined(),
  financialServicesClientType: conditionalClientTypeValidation('financialServices')
    .nullable()
    .defined(),
  businessRelationship: Yup.boolean().defined(),
  businessRelationshipClientType: clientTypeSchema.nullable().defined(),
  cardAccess: Yup.boolean().defined(),
  creditBureauData: Yup.boolean().defined(),
  phone: phoneValidation.defined(),
  email: emailValidation.defined(),
  atLeastOneCheckbox: Yup.boolean().defined().test(
    'at-least-one-checkbox',
    errorMessages.AT_LEAST_ONE_SELECTED,
    function () {
      const { financialServices, cardAccess, businessRelationship, creditBureauData } = this
        .parent as TFormValues;
      return (
        [financialServices, cardAccess, businessRelationship, creditBureauData].some(Boolean) ||
        this.createError({
          path: 'atLeastOneCheckbox',
          message: errorMessages.AT_LEAST_ONE_SELECTED,
        })
      );
    }
  ),
});
